import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CalibrationAnnualPlan } from '../../../../model/calibration';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { CalibrationAnnualPlanService } from '../../../../services/calibration-annual-plan.service';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { saveAs } from 'file-saver';
import { SignatureEditSignersComponent } from '../../../signature/signature-edit-signers/signature-edit-signers.component';
import { DocumentListEnum } from '../../../../utils/documentListUtils';

export interface DialogDataManualSignCalibrationBalance {
  calibrationPlan: CalibrationAnnualPlan;
}

@Component({
  selector: 'app-calibration-plan-edit-manual-sign-report-dialog',
  templateUrl: './calibration-plan-edit-manual-sign-report-dialog.component.html',
  styleUrl: './calibration-plan-edit-manual-sign-report-dialog.component.scss',
  standalone: false
})
export class CalibrationPlanEditManualSignReportDialogComponent  implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CalibrationPlanEditManualSignReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataManualSignCalibrationBalance,
    private calibrationAnnualPlanService: CalibrationAnnualPlanService,
    private internalEquipmentService: InternalEquipmentService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  downloadDocument(): void {
    this.spinnerService.show();
    this.calibrationAnnualPlanService.generateManualCalibrationPlanById(this.data.calibrationPlan.id).pipe(takeUntil(this.destroy$))
      .subscribe((res: File) => {
        this.spinnerService.hide();
        saveAs(res, this.data.calibrationPlan.code+".pdf");
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });
  }

  onOkClick(event): void {
    const file = event.target.files[0] as File;

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

      if (token != null) {
        this.spinnerService.show();

        this.calibrationAnnualPlanService.manualSign(this.data.calibrationPlan.id, file, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.sign.ok') as string);

          this.spinnerService.hide();
          this.data.calibrationPlan.hasManual = true;
          this.data.calibrationPlan.type = 3;
          this.dialogRef.close(this.data.calibrationPlan);
        }, () => {
          this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.sign.error') as string);

          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.hide();
      }
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openSigner() {
    const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idDocument: this.data.calibrationPlan.id,
        documentType: DocumentListEnum.ANNUAL_CALIBRATION,
        nDocument: this.data.calibrationPlan.code,
        idClient: null,
        currentVersion: this.data.calibrationPlan.currentVersion,
        isManual: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        if (result === 'manual') {
          this.data.calibrationPlan.hasManual = false;
        } else if (result === 'save') {
          this.data.calibrationPlan.hasManual = true;
          this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
        }

      }
    });
  }
}